module.exports = __webpack_public_path__ + "static/image13-fd254f0c8884c08d712cb6e1bf106672.png";